module.exports = __webpack_public_path__ + "img/User.1f83b010.svg";